import useLabel from "@apps/use-label/use-label";

export default function CoordinatorSimulationBanner({
  simulation,
}: {
  simulation?: {
    effectiveAt: string;
    recipientName: string;
    returnUrl: string;
  } | null;
}) {
  const label = useLabel();
  if (!simulation) return null;
  return (
    <aside
      aria-label="Coordinator simulation"
      className="bg-amber-50 border border-amber-300 p-3 text-sm text-gray-900"
    >
      <strong>
        Simulation · {simulation.effectiveAt} · {simulation.recipientName}
      </strong>
      <p>
        Actions can change this development {label("review")}. External
        notifications are captured. This chat keeps its simulated clock after
        reload.
      </p>
      {window.TF.hijacked ? (
        <form action="/hijack/release/" method="POST">
          <input
            type="hidden"
            name="csrfmiddlewaretoken"
            value={window.TF.csrf}
          />
          <input type="hidden" name="next" value={simulation.returnUrl} />
          <button type="submit" className="underline font-medium">
            Release impersonation and return to simulator
          </button>
        </form>
      ) : (
        <a href={simulation.returnUrl}>Return to simulator as the operator</a>
      )}
    </aside>
  );
}
